import { LineChartComponent } from '../charts/line-chart-component'

export class AFLatestActivityByMentionTypeSpline extends LineChartComponent {
 static config = {
  selector: 'afLatestActivityByMentionTypeSpline',
  controller: AFLatestActivityByMentionTypeSpline,
  bindings: LineChartComponent.config.bindings,
  template: LineChartComponent.config.template,
 }

 setProperties() {
  this.onPointClick = this.lineDateClick
  this.seriesColors = this.colorUtils.setTweetColorPalette(this.visualizationDataArray)
 }
}
